import { Brick, registerBrick } from 'olympe';

export default class AddMultFieldsToGatewayFilter extends Brick {
  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {string} plantId
   * @param {string} materialId
   * @param {string} specification
   * @param {string} body
   * @param {function()} forwardEvent
   * @param {function(string)} setBody
   */
  update($, [records, body], [forwardEvent, setBody]) {
    // Parse the bosy into a JSON object
    let query = JSON.parse(body);
    // Initialize the filters array
    const filters = [];
    // Create filters based on the input list records
    records.forEach((item, index) => {
      let spec, operator;
      const specification = item['Specification'];
    // Handle undefined specification
      typeof specification === 'undefined'
        ? ((spec = null), (operator = 'isNull'))
        : ((spec = specification), (operator = '='));

      filters.push({
        field: 'plant',
        value: String(item['Plant ID *']),
        operator: '=',
        group: index,
      });
      filters.push({
        field: 'material',
        value: item['Material ID *'],
        operator: '=',
        group: index,
      });
      filters.push({
        field: 'specification',
        value: spec,
        operator,
        group: index,
      });
    });

    // Add filters to the query object
    query.filters = filters;
    // Output the result
    const output = JSON.stringify(query);
    setBody(output);
    forwardEvent();
  }
}

registerBrick('0196ed0e073d09919f8c', AddMultFieldsToGatewayFilter);
